// Generated with util/create-component.js
import Container from './Container';

export default Container;
